
import { Component, Input } from '@angular/core';
import { App, NavController, NavParams, InfiniteScroll } from 'ionic-angular';
import { NotificationDetailsPage } from '../details/notification-details';
import { NewsListModel, NewsProvider, PagerModel } from '../../../providers/news/news';
import { LoaderProvider } from '../../../providers/loader/loader';
import { TranslateService } from '@ngx-translate/core';
import { StorageProvider } from '../../../providers/storage-service/storage-service';
import { NewsController } from '../../../providers/news/news-contoller';
import { ConfigProvider } from '../../../providers/config/config';

/**
 * Generated class for the NotificationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-notification',
  templateUrl: 'notification.html',
})
export class NotificationPage {

  @Input()
  news: NewsListModel[] = [];
  dhl: boolean = false;
  appName: string = "";

  savedSearch: PagerModel = {
    limit: '25',
    page: '1',
    start: '0'
  }
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public app: App,
    private newsService: NewsProvider,
    private loadingCtrl: LoaderProvider,
    private translate: TranslateService,
    private storageService: StorageProvider,
    private conf: ConfigProvider
  ) {
    console.log('constructior NotificationPage')
    new Promise<any>(async (resolve, reject) => {
      this.appName = (await this.conf.config).appId;
      if (navParams.data.news != null) {
        this.news = navParams.data.news;
        this.dhl = this.navParams.get('dhl');
        if (this.dhl) this.storageService.saveData(this.news, this.appName + '-news-dhl').then(() => {
          let type = (this.dhl) ? "newsDHL" : "newsGeneral";
          NewsController.getInstance().unreadNewsNumber[type] = 0;
          console.log(' NewsController.getInstance().unreadNewsNumber[type]: ', NewsController.getInstance().unreadNewsNumber[type]);
        })
      }
      else
        this.loadNews();

    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad NotificationPage');
    this.dhl = this.navParams.get('dhl');
    console.log('this.dhl: ', this.dhl);
  }

  loadNews() {
    this.newsService.getMyNews(this.savedSearch).then(results => {
      this.news = results;
      this.storageService.saveData(this.news, this.appName + '-news-general');
    })
  }

  loadNextPage(event: InfiniteScroll) {
    this.newsService.getMyNews(this.savedSearch).then(data => {
      this.news = this.news.concat(data);
      event.complete();
    });
  }

  openDetails(id: number) {
    var loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();
    this.newsService.getNews(id).then(results => {
      this.navCtrl.push(NotificationDetailsPage, { news: results }).then(() => loader.dismiss());
    })
  }

}



// WEBPACK FOOTER //
// /src/pages/notification/main/notification.ts